import { useState } from "react";
import { Gift, Check, X } from "lucide-react";
import { api, formatCHF } from "@/lib/api";

const inputCls = "min-w-0 flex-1 bg-white/60 border border-wood/25 rounded-xl px-4 py-3 text-sm font-mono uppercase tracking-wider focus:outline-none focus:border-terra";

export const GiftCodeField = ({ carte, onChange, testidPrefix }) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const apply = async () => {
    if (!code.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const c = await api.giftcard(code);
      if (c.statut !== "active" || c.solde <= 0) {
        setError("Cette carte cadeau est épuisée.");
        return;
      }
      onChange(c);
    } catch (e) {
      setError(e.response?.data?.detail || "Code introuvable.");
    } finally {
      setLoading(false);
    }
  };

  if (carte) {
    return (
      <div className="flex items-center justify-between gap-3 rounded-xl border border-sage/40 bg-sage-light/40 px-4 py-3" data-testid={`${testidPrefix}-giftcode-applied`}>
        <span className="flex items-center gap-2 text-sm text-bark">
          <Check className="w-4 h-4 text-sage" />
          <span className="font-mono tracking-wider">{carte.code}</span>
          <span className="text-fumee">· solde {formatCHF(carte.solde)}</span>
        </span>
        <button type="button" onClick={() => { onChange(null); setCode(""); }} aria-label="Retirer la carte cadeau" data-testid={`${testidPrefix}-giftcode-remove`} className="text-fumee hover:text-terra">
          <X className="w-4 h-4" />
        </button>
      </div>
    );
  }

  return (
    <div>
      <label htmlFor={`${testidPrefix}-giftcode`} className="eyebrow block mb-2 flex items-center gap-2"><Gift className="w-3.5 h-3.5" /> Carte cadeau (optionnel)</label>
      <div className="flex min-w-0 gap-2">
        <input id={`${testidPrefix}-giftcode`} data-testid={`${testidPrefix}-giftcode-input`} value={code} onChange={(e) => setCode(e.target.value)} placeholder="ELM-XXXX-XXXX" className={inputCls} />
        <button type="button" onClick={apply} disabled={loading || !code.trim()} data-testid={`${testidPrefix}-giftcode-apply`}
          className="px-4 py-3 rounded-xl border border-wood/30 text-sm text-bark hover:border-terra hover:text-terra transition-colors disabled:opacity-50">
          {loading ? "…" : "Appliquer"}
        </button>
      </div>
      {error && <p className="text-xs text-destructive mt-2" data-testid={`${testidPrefix}-giftcode-error`}>{error}</p>}
    </div>
  );
};

export const remiseCadeau = (carte, montant) => (carte ? Math.min(carte.solde, montant) : 0);
